module.exports = __webpack_public_path__ + "darkimg-createrelease.ce9f945c78a5dbc7715356fa7a12e1ff.hashedasset.svg";